import { Component } from '@angular/core';
import { Area } from '@core/area';
import { ParkProvider } from '@providers/park.provider';
import { NotificationService } from '@core/notification/notification.service';
import { BroadcasterService } from '@core/broadcaster/broadcaster.service';
import { RefreshEvent } from '@events/RefreshEvent';
import { KngActivityIndicatorService } from "@layout/kingswell/services/kngActivityIndicator.service";

@Component({
  selector: 'areas-add',
  templateUrl: './add.component.html',
  styleUrls: ['./add.component.less']
})
export class AreasAddComponent {

  public area: Area = new Area();

  constructor(private park: ParkProvider,  private kngActivityIndicator: KngActivityIndicatorService,
              private notification: NotificationService, private broadcaster: RefreshEvent) {}

  submit(area: Area) {
    this.park.addArea(area).then((res) => {
      this.kngActivityIndicator.close();
      this.notification.show('success', 'You have successfully added ' + area.name + ".");
      this.broadcaster.fire('refresh.lands');
    });
  }

}



// WEBPACK FOOTER //
// D:/dclean-web-latest/task/cot-web/src/app/components/areas/add/add.component.ts